import { API, API_AUTH } from "./common";

const AuthApi = {
  register: (data) => {
    return API.post("api/register/trial", data);
  },
  login: (data) => {
    return API.post("oauth/token3", data);
  },
  QuenMatKhau: (data) => {
    return API.post("oauth/QuenMatKhau", data);
  },
  KhoiPhucMatKhau: (data) => {
    return API.post("oauth/KhoiPhucMatKhau", data);
  },
  luuDiaChiIP: ({ ip }) => {
    return API_AUTH.post(`oauth/luuDiaChiIp?ip=${ip}`, {});
  },
};

export default AuthApi;
